import { render, staticRenderFns } from "./DonationDataOverview.vue?vue&type=template&id=c0ed7a3a"
import script from "./DonationDataOverview.vue?vue&type=script&lang=js"
export * from "./DonationDataOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports